import DistributorLogo from "./DistributorLogo";
import DistributorLogoThemes from "./DistributorLogoThemes";

export { DistributorLogoThemes };
export default DistributorLogo;
